import { useState, useEffect } from "react";
import { ITeamInfo } from "../types/types";
import { fetchTeamInfo } from "../services/services";
import { TeamsContext } from "./context";

export const TeamsProvider = ({ children }: { children: React.ReactNode }) => {
  const [teamInfos, setTeamInfos] = useState<ITeamInfo[]>([]);

  useEffect(() => {
    async function getTeamInfo() {
      try {
        const infos = await fetchTeamInfo();
        setTeamInfos(infos);
      } catch (error) {
        console.log(error);
      }
    }
    void getTeamInfo();
  }, []);

  return <TeamsContext.Provider value={teamInfos}>{children}</TeamsContext.Provider>;
};
